'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import BuildIntelligence from '@/components/common/build-intelligence';
import ValuePropositionVisionMultimodal from '@/components/common/value-proposition-vision-multimodal-ai';
import WhyVisionMultimodalAi from '@/components/common/why-vision-multimodal-ai';
import OurOfferingVisionMultimodal from '@/components/common/our-offering-vision-multimodal-ai';
import TechnicalApproachVisionMultimodal from '@/components/common/technical-approach-vision-multimodal-ai';
import VisionMultimodalAiFAQ from '@/components/faqs/vision-multimodal-ai-faq';
import IntegrationsTechVisionMultimodal from '@/components/common/integrations-tech-vision-multimodal-ai';
import VisionMultimodalTechStack from '@/components/home/vision-multimodal-ai-tech-stack';
import ArchitectureDiagramVisionMultimodalAi from '@/components/common/architecture-diagram-vision-multimodal-ai';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroVisionMultimodalAi = dynamic(() => import('@/components/technologies/tech-hero-vision-multimodal-ai'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroVisionMultimodalAi />
                <BuildIntelligence />
                <ValuePropositionVisionMultimodal />
                <WhyVisionMultimodalAi />
                <OurOfferingVisionMultimodal />
                
                <TechnicalApproachVisionMultimodal />
                <ArchitectureDiagramVisionMultimodalAi />
                <IntegrationsTechVisionMultimodal />
                <VisionMultimodalTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for Vision AI & Multimodal AI" bg="bg-aiml-faq">
                    <VisionMultimodalAiFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
